import React from "react";

interface XIconProps {
    rotate?: number;
}

export default function XIcon(props: XIconProps) {
    return <svg style={props.rotate ? {
        transform: "rotate(" + props.rotate + "deg)"
    } : {}} xmlns="http://www.w3.org/2000/svg" width="17.1" height="17.1" viewBox="0 0 17.1 17.1">
        <g id="Gruppe_271" data-name="Gruppe 271" transform="translate(-2.041 -2.041)">
            <path id="Linie_95" data-name="Linie 95" d="M21.183,1.5H0v-3H21.183Z" transform="translate(3.102 3.102) rotate(45)" fill="currentColor"/>
            <path id="Linie_96" data-name="Linie 96" d="M21.183,1.5H0v-3H21.183Z" transform="translate(18.08 3.102) rotate(135)" fill="currentColor"/>
        </g>
    </svg>
    ;  
}